var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.65857V13.2284L4.09816 9.36112C0.503012 6.99018 2.40855 8.24666 0 6.65857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9043 9.36112L14.0022 13.2284V6.65857C14.0005 6.65967 9.90594 9.36005 9.9043 9.36112Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22528 11.1253C7.08814 11.216 6.90924 11.2162 6.77179 11.1253L4.80301 9.82684L0.623047 13.7713H13.374L9.19434 9.82684L7.22528 11.1253Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81732 0.0686L5.67188 1.07849H8.32584L7.18039 0.0686C7.07665 -0.0228667 6.92106 -0.0228667 6.81732 0.0686Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47478 6.64639C1.47478 5.70249 1.47478 5.75495 1.47478 4.77698C0.524837 5.6144 0.784523 5.38546 0.261719 5.84647C0.261719 5.84647 0.872476 6.24934 1.47478 6.64639Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7365 5.84647C13.2226 5.39333 13.52 5.65552 12.5234 4.77698V6.64639C13.1248 6.24994 13.7365 5.84647 13.7365 5.84647Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00152 10.2884C8.3506 9.39883 10.1268 8.22744 11.7003 7.18971V2.17661C11.7003 2.025 11.5774 1.9021 11.4258 1.9021H2.57724C2.42563 1.9021 2.30273 2.025 2.30273 2.17661V7.18971C6.40759 9.89687 4.8517 8.87086 7.00152 10.2884ZM4.88395 3.81433H9.11909C9.34638 3.81433 9.53085 3.99881 9.53085 4.2261C9.53085 4.45367 9.34638 4.63786 9.11909 4.63786H4.88395C4.65666 4.63786 4.47219 4.45367 4.47219 4.2261C4.47219 3.99881 4.65666 3.81433 4.88395 3.81433ZM4.47219 6.30551V6.30277C4.47219 6.09139 4.63195 5.91681 4.83728 5.89375H9.16575C9.37109 5.91681 9.53085 6.09139 9.53085 6.30277V6.30551C9.52948 6.53171 9.34556 6.71453 9.11909 6.71453H4.88395C4.65748 6.71453 4.47356 6.53171 4.47219 6.30551Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d2341c791e79db136189c4dca722a90d.svg";
export { ForwardRef as ReactComponent };